import isdlAccessInstance from './isdlAccessInstance';
import { isEmailCleanable, cleanEmail } from '../utils/Utilities';

let loadedUsers = {};

//GET

//Users_GetFilteredUsers
export const getFilteredUsers = async (searchTerm) => await isdlAccessInstance.userData.GetFilteredUsers(searchTerm);

//Users_GetUser
export const getUser = async (userId) => await isdlAccessInstance.userData.GetUser(userId);

//Users_GetUserMin
export const getUserMin = async (userId) => await isdlAccessInstance.userData.GetUserMin(userId);

//POST

//Users_UpdateUser, Users_AddUser
export const upsertUser = async (data) => await isdlAccessInstance.userData.UpsertUser(data);

export const UpdateUser = async (existingUser) => {
  loadedUsers[existingUser.id] = existingUser;
  await upsertUser(existingUser);
};

export const AddUser = async (newUser) => {
  await upsertUser(newUser);
};

export const GetUser = async (userEmail) => {
  if (!userEmail) {
    return null;
  }

  let cleanedEmail = userEmail;

  if(isEmailCleanable(userEmail)){
    cleanedEmail = cleanEmail(userEmail).toLowerCase();
  }

  if (loadedUsers[cleanedEmail]) {
    return loadedUsers[cleanedEmail];
  }

  let userData = null;

  try {
    userData = await getUser(cleanedEmail);
  } catch (error) {
    if (error?.message === 'HTTP error 404') {
      return null;
    }

    throw error;
  }

  if (!userData) {
    return null;
  }

  loadedUsers[cleanedEmail] = userData;

  return userData;
};

//User settings
//Shotlist Columns
//Favorites
export const GetUserShotlistColumnFavorites = async () => {
  const user = await GetUser(sessionStorage.getItem('dataCollectorEmail'));

  return user?.Settings?.ShotList?.Columns?.Favorites ?? null;
};
export const SetUserShotlistColumnFavorites = async (favs) => {
  const user = await GetUser(sessionStorage.getItem('dataCollectorEmail'));

  if (!user) return;

  user.Settings ??= {};
  user.Settings.ShotList ??= {};
  user.Settings.ShotList.Columns ??= {};

  user.Settings.ShotList.Columns.Favorites = favs;

  await UpdateUser(user);
};

//Order
export const GetUserShotlistColumnOrder = async () => {
  const user = await GetUser(sessionStorage.getItem('dataCollectorEmail'));

  return user?.Settings?.ShotList?.Columns?.Order ?? null;
};
export const SetUserShotlistColumnOrder = async (order) => {
  const user = await GetUser(sessionStorage.getItem('dataCollectorEmail'));

  if (!user) return;

  user.Settings ??= {};
  user.Settings.ShotList ??= {};
  user.Settings.ShotList.Columns ??= {};

  user.Settings.ShotList.Columns.Order = order;

  await UpdateUser(user);
};

//Direction
export const GetUserShotlistColumnDirection = async () => {
  const user = await GetUser(sessionStorage.getItem('dataCollectorEmail'));

  return user?.Settings?.ShotList?.Columns?.Direction ?? null;
};
export const SetUserShotlistColumnDirection = async (direction) => {
  const user = await GetUser(sessionStorage.getItem('dataCollectorEmail'));

  if (!user) return;

  user.Settings ??= {};
  user.Settings.ShotList ??= {};
  user.Settings.ShotList.Columns ??= {};

  user.Settings.ShotList.Columns.Direction = direction;

  await UpdateUser(user);
};

//Test function for getting outlook user directory, currently doesn't work but keeping for future uses
export const GetGraphUsers = async () => {
  const authToken = sessionStorage.getItem('authToken');

  // Call Microsoft Graph API to fetch directory data
  const response = await fetch('https://graph.microsoft.com/v1.0/users', {
      headers: {
        Authorization: `Bearer ${authToken}`,
      },
    });
    const data = await response.json();

    console.log(data);
}
